'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const zonedMoment=require('pulsar-utils/dist-es6/time/zonedMoment');
const moment=require('pulsar-utils/dist-es6/time/moment');
const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

DebugToolsDirective=function(_BaseControllerBacked){_inherits(DebugToolsDirective,_BaseControllerBacked);function DebugToolsDirective(){_classCallCheck(this,DebugToolsDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(DebugToolsDirective,[{key:'templateUrl',get:function()
{return'/templates/directives/debugToolsDirective/debugToolsTemplate'}},{key:'controller',get:function()

{return DebugToolsDirectiveController}},{key:'$inject',get:function()

{return['$scope','$interval','$timeout','$mdSidenav','$mdToast','dateService','timeZoneService','socketService']}}]);return DebugToolsDirective}(BaseControllerBackedDirective);


const AdditionalTimeZoneOptions=[
'Asia/Dubai'];let


DebugToolsDirectiveController=function(){
function DebugToolsDirectiveController($scope,$interval,$timeout,$mdSidenav,$mdToast,dateService,timeZoneService,socketService){var _this2=this;_classCallCheck(this,DebugToolsDirectiveController);
this._$scope=$scope;
this._$interval=$interval;
this._$timeout=$timeout;
this._$mdToast=$mdToast;

this._dateService=dateService;
this._dateService.reset();

this._timeZoneService=timeZoneService;
this._timeZoneService.reset();

this._socketService=socketService;

this.toolsVisible=!1;

this._localTimeZone=this._timeZoneService.localTimeZone;

this.mockDate=this._dateService.currentDateString();
this.mockTimeZone=this._timeZoneService.localTimeZone;
this.availableTimeZoneOptions=_.uniq([this._timeZoneService.localTimeZone].concat(AdditionalTimeZoneOptions).concat(this._timeZoneService.USIanaTimeZones));
this.currentMockState=[this._dateService.isMocked,this._timeZoneService.isMocked].every(function(v){return v===!0});

this.enableDigestSpeedMonitor=!0;

this._$mdSidenav=$mdSidenav;

this._$scope.$watchGroup(['controller.mockDate','controller.mockTimeZone'],function(){
const date=_this2.mockDate instanceof Date?_this2.mockDate:new Date(_this2.mockDate);
if(date.getTime()===Number.NaN){
console.error(`MockDate is not a valid date: ${_this2.mockDate}`);
return;
}

if(!_.exists(moment.tz(_this2.mockTimeZone))){
console.error(`MockTimeZone is not a valid timezone: ${_this2.mockTimeZone}`);
return;
}

_this2.updateCurrentMockState();
});

this.updateCurrentMockState();
}DebugToolsDirectiveController.prototype.

updateCurrentMockState=function updateCurrentMockState(){
const dateFromCalendar=moment(this.mockDate).format(`YYYY-MM-DD`);
this._mockDateInTimeZone=zonedMoment(dateFromCalendar,this.mockTimeZone).format(`YYYY-MM-DD HH:mm z`);

if(this.currentMockState){
this.enableMockDate();
return;
}

this.resetServicesToNormal();
};DebugToolsDirectiveController.prototype.





closeToolsSidebar=function closeToolsSidebar(){
this._sidebarElement.close();
};DebugToolsDirectiveController.prototype.

toggleToolsSidebar=function toggleToolsSidebar(){
this._sidebarElement.toggle();
};DebugToolsDirectiveController.prototype.





















enableMockDate=function enableMockDate(){
this._dateService.setMockDate(this.mockDate);
this._timeZoneService.setMockTimeZone(this.mockTimeZone);
this.currentMockState=!0;
};DebugToolsDirectiveController.prototype.

resetServicesToNormal=function resetServicesToNormal(){
this._dateService.reset();
this._timeZoneService.reset();
this.currentMockState=!1;
};DebugToolsDirectiveController.prototype.

logCurrentFeatureControllerToConsole=function logCurrentFeatureControllerToConsole(){
console.dir(angular.element('[data-ui-view="main"]').controller());
const toast=this._$mdToast.simple().textContent('Printed main controller to console').position('top right').hideDelay(1618);
this._$mdToast.show(toast);
};_createClass(DebugToolsDirectiveController,[{key:'_sidebarElement',get:function(){return this.__sidebarElement||(this.__sidebarElement=this._$mdSidenav('debug-tools'))}},{key:'mockDateInTimeZone',get:function(){return this._mockDateInTimeZone}},{key:'useMockConnectionStatus',get:function(){return this._socketService.useMockConnectionStatus},set:function(useMockConnectionStatus){return this._socketService.useMockConnectionStatus=useMockConnectionStatus}},{key:'mockConnectionStatus',get:function(){return this._socketService.mockConnectionStatus},set:function(mockConnectionStatus){return this._socketService.mockConnectionStatus=mockConnectionStatus}}]);return DebugToolsDirectiveController}();


module.exports=DebugToolsDirective;
//# sourceMappingURL=debugToolsDirective.js.map
